import React from 'react';
import * as styles from '../css/details-section.css';
import { classNames } from '../utils';
import HorizontalContentPadding from '../containers/HorizontalContentPadding';

interface Props {
    children: React.ReactNode;
    className?: string;
}

const DetailsSection = ({ children, className }: Props) => (
    <HorizontalContentPadding className={classNames(styles.root, className)}>
        {children}
    </HorizontalContentPadding>
);

export default DetailsSection;
